// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/logoBabitaW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/insta.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/face.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../imgs/youtube.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rodape {
    display: flex;
    position: relative;
    justify-content: space-between;
    background-color: #000000;
    width: 100%;
    overflow-x: hidden;
    height: 12vh;
    box-shadow: 0px 0px 15px 0px #00000040;
    font-family: 'Cardo-Bold';
    color: var(--white-color);
    z-index: 10000 !important;
}


.rodape .logo{
    height: 55%;
    margin-left: 5vw;
    /* background-color: #FFF; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    aspect-ratio: 25/8;
    width: fit-content;
}

.rodape > div{
    margin: auto 0;
}

.rodape .socials{
    font-size: 1.18em;
    margin-right: 5vw;
}

.rodape .logosSocial{
    display: flex;
    width: max-content;
    margin-bottom: 5%;
    cursor: pointer;
}

.rodape .logosSocial div:hover{
    opacity: 0.8;
}

.rodape .logosSocial div{
    height: 40px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 10%;
}

.rodape .instaSoc{
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.rodape .faceSoc{
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.rodape .youtSoc{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    width: 57px;
}

@media(max-width: 1400px){
    .rodape {
        height: 15vh;
        padding: 1% 0;
    }
}

@media(max-width: 767px){
    .rodape {
        flex-direction: column;
        align-items: center;
        padding: 7% 0;
        height: max-content;
    }

    .rodape .logo {
        height: auto;
        width: 40vw;
        margin: 2% auto 5% auto;
    }

    .rodape .socials {
        font-size: 1.5em;
        margin-right: 0;
        width: 60%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .rodape .logosSocial div {
        margin-left: 0%;
    }

    .rodape .logosSocial {
        width: 80%;
        justify-content: space-evenly;
    }

    .rodape .lineBarRodape{
        height: 3px;
        width: 90%;
        margin: 5% auto 6% auto;
        background-color: var(--white-color);
    }

    .rodape .info{
        font-size: 1.4em;
        width: 85%;
    }

    .rodape .info div:nth-child(1){
        margin-bottom: 3%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/rodape.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IAGZ,sCAAsC;IACtC,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,yDAAgD;IAChD,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAElB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yDAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,yDAAyC;AAC7C;;AAEA;IACI,yDAA4C;IAC5C,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;QACvB,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".rodape {\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: space-between;\r\n    background-color: #000000;\r\n    width: 100%;\r\n    overflow-x: hidden;\r\n    height: 12vh;\r\n    -webkit-box-shadow: 0px 0px 15px 0px #00000040;\r\n    -moz-box-shadow: 0px 0px 15px 0px #00000040;\r\n    box-shadow: 0px 0px 15px 0px #00000040;\r\n    font-family: 'Cardo-Bold';\r\n    color: var(--white-color);\r\n    z-index: 10000 !important;\r\n}\r\n\r\n\r\n.rodape .logo{\r\n    height: 55%;\r\n    margin-left: 5vw;\r\n    /* background-color: #FFF; */\r\n    background-image: url('../imgs/logoBabitaW.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    aspect-ratio: 25/8;\r\n    width: -moz-fit-content;\r\n    width: fit-content;\r\n}\r\n\r\n.rodape > div{\r\n    margin: auto 0;\r\n}\r\n\r\n.rodape .socials{\r\n    font-size: 1.18em;\r\n    margin-right: 5vw;\r\n}\r\n\r\n.rodape .logosSocial{\r\n    display: flex;\r\n    width: max-content;\r\n    margin-bottom: 5%;\r\n    cursor: pointer;\r\n}\r\n\r\n.rodape .logosSocial div:hover{\r\n    opacity: 0.8;\r\n}\r\n\r\n.rodape .logosSocial div{\r\n    height: 40px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    margin-left: 10%;\r\n}\r\n\r\n.rodape .instaSoc{\r\n    width: 40px;\r\n    background-image: url('../imgs/insta.png');\r\n}\r\n\r\n.rodape .faceSoc{\r\n    width: 40px;\r\n    background-image: url('../imgs/face.png');\r\n}\r\n\r\n.rodape .youtSoc{\r\n    background-image: url('../imgs/youtube.png');\r\n    width: 57px;\r\n}\r\n\r\n@media(max-width: 1400px){\r\n    .rodape {\r\n        height: 15vh;\r\n        padding: 1% 0;\r\n    }\r\n}\r\n\r\n@media(max-width: 767px){\r\n    .rodape {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 7% 0;\r\n        height: max-content;\r\n    }\r\n\r\n    .rodape .logo {\r\n        height: auto;\r\n        width: 40vw;\r\n        margin: 2% auto 5% auto;\r\n    }\r\n\r\n    .rodape .socials {\r\n        font-size: 1.5em;\r\n        margin-right: 0;\r\n        width: 60%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n\r\n    .rodape .logosSocial div {\r\n        margin-left: 0%;\r\n    }\r\n\r\n    .rodape .logosSocial {\r\n        width: 80%;\r\n        justify-content: space-evenly;\r\n    }\r\n\r\n    .rodape .lineBarRodape{\r\n        height: 3px;\r\n        width: 90%;\r\n        margin: 5% auto 6% auto;\r\n        background-color: var(--white-color);\r\n    }\r\n\r\n    .rodape .info{\r\n        font-size: 1.4em;\r\n        width: 85%;\r\n    }\r\n\r\n    .rodape .info div:nth-child(1){\r\n        margin-bottom: 3%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
